import { IForm } from 'core-components/classes/models/IForm'
import { getFormatDate } from 'core/classes/helpers/DateHelper'

import { partnerAuditTranslation } from './translation'

export const columns = [
  {
    field: 'Created',
    title: partnerAuditTranslation.table.columns.created,
    priority: 1,
    renderFunction: ({ Created }: IForm) => <>{getFormatDate(new Date(Created), 'full')}</>,
  },
  { field: 'TriggerAction', title: partnerAuditTranslation.table.columns.action, priority: 2 },
  {
    field: 'ModifiedBySource',
    title: partnerAuditTranslation.table.columns.sourse,
    priority: 3,
  },
  { field: 'PartnerID', title: partnerAuditTranslation.table.columns.partnerId, priority: 4 },
  {
    field: 'LegalWorkflowStatus',
    title: partnerAuditTranslation.table.columns.workflowStatus,
    priority: 5,
  },
  {
    field: 'LegalModifiedValues',
    title: partnerAuditTranslation.table.columns.modifiedValues,
    priority: 6,
  },
  { field: 'LegalAddr1', title: partnerAuditTranslation.table.columns.addr1, priority: 7 },
  { field: 'LegalAddr2', title: partnerAuditTranslation.table.columns.addr2, priority: 8 },
  { field: 'LegalAddr3', title: partnerAuditTranslation.table.columns.addr3, priority: 9 },
  { field: 'LegalCity', title: partnerAuditTranslation.table.columns.city, priority: 10 },
  { field: 'LegalCountry', title: partnerAuditTranslation.table.columns.country, priority: 11 },
  {
    field: 'LegalPostalCode',
    title: partnerAuditTranslation.table.columns.zipCode,
    priority: 12,
  },
  {
    field: 'CompanyLegalName',
    title: partnerAuditTranslation.table.columns.companyLegalName,
    priority: 13,
  },
  {
    field: 'LegalProfilingComment',
    title: partnerAuditTranslation.table.columns.profilingComment,
    priority: 14,
  },
  {
    field: 'LegalApproverComment',
    title: partnerAuditTranslation.table.columns.approverComment,
    priority: 15,
  },
]
